module.exports = __webpack_public_path__ + "static/media/twitterIcon.3c0f2aa4.svg";